import React from 'react'

const Heading = ({children}) => <p className='dashboard-heading'>{children}</p>

export default Heading